import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Reveal } from "../../Components/Reveal/Reveal";
import "./style.css";
import ButtonMailto from "../../Components/MailToButton/ButtonMailTo";
import { ContactSection } from "../../Components/ContactSection/ContactSection";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { BsTelephone } from "react-icons/bs";

export const Contact = (prop) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    prop.setSelectedPage("contact");
  }, []);
  return (
    <>
      <Helmet>
        <title>Contact - DataDept | Book your appointment with DataDept</title>
        <meta
          name="description"
          content="Reach out to DataDept for custom software development and IT consulting. Contact us today to discuss your project needs and discover how we can drive your business forward."
        />
        <link rel="canonical" href="/contact-us" />
      </Helmet>
      <section className="about-page-section-1 container-style">
        <div className="content-sizing about-page-section-1-wrapper">
          <div className="header-into-about-section">
            <Reveal delay={0.1}>
              <span className="light-tag">Contact Us</span>
            </Reveal>
            <Reveal delay={0.2}>
              <h1 className="header-tag-about">We are always open to talk</h1>
            </Reveal>
            <Reveal delay={0.3}>
              <h2 className="sub-header-tag-about">
                We have offices and teams all over Canada.
              </h2>
            </Reveal>
          </div>

          <div className="contact-box-2-contact-page">
            <Reveal>
              <div className="contact-support-single-item">
                <span>
                  <TfiHeadphoneAlt />
                </span>
                <h3>Support</h3>
                <p>Contact our fast support team</p>
                <ButtonMailto label={"datadept.ca@gmail.com"} />
              </div>
            </Reveal>
            <Reveal>
              <div className="contact-support-single-item">
                <span>
                  <BsTelephone />
                </span>
                <h3>Phone</h3>
                <p>Open 24 hours</p>
                <a>+1 204-333-4080</a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};
